import { useConfigCatClient } from "configcat-react";
import flash from "../../services/flash";
import SubtleButton from "../../components/Buttons/SubtleButton";

export default function ConfigCatRefresh() {
  const client = useConfigCatClient();

  const handleRefresh = async () => {
    await client.forceRefreshAsync();
    flash.success("ConfigCat settings refreshed");
  };

  return (
    <div>
      <h2 className="font-semibold mb-2">ConfigCat</h2>
      <SubtleButton onClick={handleRefresh}>Update Feature Flags</SubtleButton>
    </div>
  );
}
